var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#faa625" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v125.792c1 .082.99.235 1.359.235 36.269.011 72.665.011 108.934.011 4.994 0 9.859.004 14.854-.011.328-.001.854-.153.854-.235L127 1H1zm114 62.914v48.551c0 1.688-.253 1.535-1.88 1.535H15.771c-1.627 0-1.771.154-1.771-1.534V15.24c0-1.689.144-2.24 1.894-2.24h97.103c1.751 0 2.003.551 2.003 2.363v48.551zM64.414 40.368c-.214-.662-.612-.696-1.193-.693-3.114.019-6.229.069-9.341 0-.984-.021-1.411.274-1.715 1.233-4.385 13.785-8.817 27.561-13.233 41.336-.72 2.246-1.417 4.501-2.185 6.939 2.911 0 5.571-.04 8.229.026.903.022 1.279-.275 1.525-1.126 1.138-3.924 2.37-7.821 3.497-11.748.265-.926.694-1.176 1.625-1.165 4.424.052 8.85.052 13.274 0 .861-.01 1.211.268 1.455 1.062 1.213 3.949 2.502 7.874 3.714 11.823.251.816.566 1.13 1.507 1.062a54.147 54.147 0 013.93-.117h4.592l-.021-.331c-5.222-16.107-10.451-32.19-15.66-48.301zM52.001 68c2.037-7 4.059-13.848 6.051-20.644C60.105 54.128 62.193 61 64.312 68H52.001zM82 89h10V53H82v36zm5.071-50.445c-2.963.003-5.151 2.107-5.131 4.936.02 2.837 2.122 4.857 5.057 4.862 3.051.004 5.208-2.015 5.187-4.856-.022-2.91-2.127-4.945-5.113-4.942z",
    fillRule: "evenodd"
  }));
};